import i18n from '@/i18n';

const { t } = i18n;

export const validateMessage = (value: string) => {
  if (!value) return t('form.errors.messageRequired', { ns: 'contact' });
  if (value.length > 500)
    return t('form.errors.messageLengthExceeded', { ns: 'contact' });
  return '';
};
